import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
const imgPath = '/i3/saas_templates/shopiko/';

const BG = [
	{
		name: 'Luxury',
		img: imgPath + 'Luxury.jpg',
		href: 'https://luxury.shopiko.bg',
		tags: [
			{
				name: 'ново',
				color: '' // Example color-brand-green-500
			}
		]
	},
	{
		name: 'Boutique',
		img: imgPath + 'Boutique.jpg',
		href: 'https://boutique.shopiko.bg',
		tags: [
			{
				name: 'ново',
				color: '' // Example color-brand-green-500
			}
		]
	},
	{
		name: 'Imagine',
		img: imgPath + 'Imagine.jpg',
		href: 'https://imagine.shopiko.bg',
		tags: [
			{
				name: 'ново',
				color: '' // Example color-brand-green-500
			}
		]
	}
];

///////////////////////////////////////////////////////////////////////////////////////////

const EN = [
	{
		name: 'Luxury',
		img: imgPath + 'Luxury.jpg',
		href: 'https://luxury.shopiko.bg',
		tags: [
			{
				name: 'ново',
				color: '' // Example color-brand-green-500
			}
		]
	},
	{
		name: 'Boutique',
		img: imgPath + 'Boutique.jpg',
		href: 'https://boutique.shopiko.bg',
		tags: [
			{
				name: 'ново',
				color: '' // Example color-brand-green-500
			}
		]
	},
	{
		name: 'Imagine',
		img: imgPath + 'Imagine.jpg',
		href: 'https://imagine.shopiko.bg',
		tags: [
			{
				name: 'ново',
				color: '' // Example color-brand-green-500
			}
		]
	}
];

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];